<app-curve-chart-view [entityType]="entityType"></app-curve-chart-view>
